import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { EmailTranscriptActions } from './email-transcript.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { EmailTranscriptEffects } from './email-transcript.effects';
import { EmailTranscriptStatus } from '../../types/enum';

export const initialState: Readonly<string> = '';

export const emailTranscriptFeature = createFeature({
  name: 'emailTranscript',
  reducer: createReducer(
    initialState,
    on(EmailTranscriptActions.requestTranscript, () => {
      return EmailTranscriptStatus.Requested;
    }),
    on(EmailTranscriptActions.setSubmitted, () => {
      return EmailTranscriptStatus.Submitted;
    }),
    on(EmailTranscriptActions.setFailed, () => {
      return EmailTranscriptStatus.Failed;
    })
  ),
});

export const { selectEmailTranscriptState } = emailTranscriptFeature;

export function provideEmailTranscriptFeature() {
  return makeEnvironmentProviders([
    provideState(emailTranscriptFeature),
    provideEffects(EmailTranscriptEffects),
  ]);
}
